import React, { useState, useEffect } from 'react';
import noUiSlider from 'nouislider';
import { formatNumberWithComma, formatNumberToDollar } from '../../util/formatNumber';

const Slider = ({
  title,
  minValue,
  maxValue,
  selectedMinValue,
  selectedMaxValue,
  minInputLabel,
  maxInputLabel,
  step,
  currency,
  onSliderChange,
  maxPricePlus
}) => {
  const [leftHandle, setLeftHandle] = useState(0);
  const [rightHandle, setRightHandle] = useState(0);

  useEffect(() => {
    const left = selectedMinValue ? selectedMinValue : minValue;
    const right = selectedMaxValue ? selectedMaxValue : maxValue;
    setLeftHandle(left);
    setRightHandle(right);
  }, [selectedMinValue, selectedMaxValue, minValue, maxValue]);

  // update hook for the noUiSlider component
  useEffect(() => {
    const slider = document.getElementById(title);
    if (slider.noUiSlider) {
      slider.noUiSlider.updateOptions({
        range: {
          min: minValue,
          max: maxValue
        },
        start: [leftHandle, rightHandle],
        step: step
      })
    } else {
      noUiSlider.create(slider, {
        range: {
          min: minValue,
          max: maxValue
        },
        start: [leftHandle, rightHandle],
        handleAttributes: [
          { 'aria-label': 'price range minimum' },
          { 'aria-label': 'price range maximum' },
        ],
        step: step,
        connect: [false, true, false]
      });

      slider.noUiSlider.on('change', handleSlider)
    }
  }, [leftHandle, rightHandle, minValue, maxValue, step])

  const handleSlider = (value) => {
    onSliderChange({
      selectedMin: parseInt(value[0]),
      selectedMax: parseInt(value[1])
    });
  };

  return (
    <fieldset className="range-slider">
      <legend className="filter-title" aria-label={title}>{title}</legend>
      <div id={title}></div>
      <div className="range-input-container">
        <div className="range-input">
          <label htmlFor="leftHandleInput">{minInputLabel}</label>
          <input
            name="leftHandle"
            id={`leftHandleInput`}
            readOnly
            value={currency ? formatNumberToDollar(leftHandle) : formatNumberWithComma(leftHandle)}
          />
        </div>
        <span>–</span>
        <div className={ maxPricePlus ? 'range-input plus' : 'range-input'}>
          <label htmlFor="rightHandleInput">{maxInputLabel}</label>
          <input
            name="rightHandle"
            id={`rightHandleInput`}
            value={currency ? formatNumberToDollar(rightHandle) : formatNumberWithComma(rightHandle)}
            readOnly
          />
        </div>
      </div>
    </fieldset>
  );
};

export default Slider;
